"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var gateway_module_1 = require("../gateway-module");
var EnterpriseModule = /** @class */ (function (_super) {
    __extends(EnterpriseModule, _super);
    function EnterpriseModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 下拉列表联动选择
     * @param parentId 父级Id 不传表示查询省份列表  传表示查询对应Id下的子级列表
     */
    EnterpriseModule.prototype.getDistrictSelective = function (parentId) {
        return this.gatewayClient.getDistrictSelective(parentId);
    };
    ////////////////////////////// 企业信息管理start ////////////////////////////
    /**
     * 条件查询企业用户
     * @param extensionClerk
     * @param id
     * @param juridicalPerson
     * @param name
     * @param page
     * @param property
     * @param size
     */
    EnterpriseModule.prototype.queryCompanyList = function (params, token) {
        return this.gatewayClient.queryCompanyList(params, token);
    };
    /**
     * 新增/修改企业
     * param address
     * param area
     * param businessLicenceUrL
     * param city
     * param discount
     * param extensionClerk
     * param juridicalPerson
     * param landlineTelephone
     * param licenseCode
     * param name
     * param phone
     * param property
     * param province
     * param scale
     * param id
     */
    EnterpriseModule.prototype.editCompany = function (params, token) {
        return this.gatewayClient.editCompany(params, token);
    };
    /**
     * 删除企业
     * @param id
     */
    EnterpriseModule.prototype.deleteCompany = function (id, token) {
        return this.gatewayClient.deleteCompany(id, token);
    };
    /**
     * 查询推广员
     */
    EnterpriseModule.prototype.queryCms = function (token) {
        return this.gatewayClient.queryCms(token);
    };
    /**
     * 修改企业用户员工
     * @param enterpriseId
     * @param id
     * @param mobile
     * @param name
     * @param registrationDate
     */
    EnterpriseModule.prototype.changeCompanyEmployees = function (params, token) {
        return this.gatewayClient.changeCompanyEmployees(params, token);
    };
    /**
     * 企业员工信息导入
     * @param enterpriseId
     * @param file
     */
    EnterpriseModule.prototype.importEmployeesInfo = function (
        // params: {
        //   enterpriseId: number;
        //   file: object;
        // },
        enterpriseId, file, token) {
        return this.gatewayClient.importEmployeesInfo(enterpriseId, file, token);
    };
    /**
     * 批量修改企业折扣
     * @param discount
     * @param ids
     */
    EnterpriseModule.prototype.changeCompanyDiscount = function (params, token) {
        return this.gatewayClient.changeCompanyDiscount(params, token);
    };
    /**
     * 条件查询企业员工
     * @param enterpriseId
     * @param id
     * @param mobile
     * @param name
     */
    EnterpriseModule.prototype.queryCompanyEmployess = function (params, token) {
        return this.gatewayClient.queryCompanyEmployess(params, token);
    };
    /**
     * 查看企业详情
     * @param id
     */
    EnterpriseModule.prototype.queryCompanyDetails = function (id, token) {
        return this.gatewayClient.queryCompanyDetails(id, token);
    };
    /**
     * 条件企业用户报表
     * @param consumeEndfDate
     * @param consumeStartDate
     * @param extensionClerk
     * @param page
     * @param registrationEndDate
     * @param registrationStartDate
     * @param size
     */
    EnterpriseModule.prototype.queryCompanyUserReport = function (params, token) {
        return this.gatewayClient.queryCompanyUserReport(params, token);
    };
    /**
     * 删除企业用户员工
     * @param id
     */
    EnterpriseModule.prototype.deleteCompanyUserEmployesss = function (id, token) {
        return this.gatewayClient.deleteCompanyUserEmployesss(id, token);
    };
    /**
     * 添加企业用户员工
     * @param enterpriseId
     * @param mobile
     * @param name
     */
    EnterpriseModule.prototype.addCompanyUserEmployess = function (params, token) {
        return this.gatewayClient.addCompanyUserEmployess(params, token);
    };
    return EnterpriseModule;
}(gateway_module_1.GatewayModule));
exports.EnterpriseModule = EnterpriseModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvYXBpcy9vbXMvbW9kdWxlcy9lbnRlcnByaXNlL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUVBLG9EQUFrRDtBQUVsRDtJQUFzQyxvQ0FBYTtJQUFuRDs7SUFnT0EsQ0FBQztJQS9OQzs7O09BR0c7SUFDSSwrQ0FBb0IsR0FBM0IsVUFBNEIsUUFBaUI7UUFDM0MsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsb0JBQW9CLENBQUMsUUFBUSxDQUFDLENBQUM7SUFDM0QsQ0FBQztJQUVELHVFQUF1RTtJQUN2RTs7Ozs7Ozs7O09BU0c7SUFDSSwyQ0FBZ0IsR0FBdkIsVUFDRSxNQVFDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLGdCQUFnQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUM1RCxDQUFDO0lBRUQ7Ozs7Ozs7Ozs7Ozs7Ozs7O09BaUJHO0lBQ0ksc0NBQVcsR0FBbEIsVUFDRSxNQW1CQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxXQUFXLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3ZELENBQUM7SUFFRDs7O09BR0c7SUFDSSx3Q0FBYSxHQUFwQixVQUFxQixFQUFVLEVBQUUsS0FBYTtRQUM1QyxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxhQUFhLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ3JELENBQUM7SUFFRDs7T0FFRztJQUNJLG1DQUFRLEdBQWYsVUFBZ0IsS0FBYTtRQUMzQixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDNUMsQ0FBQztJQUVEOzs7Ozs7O09BT0c7SUFDSSxpREFBc0IsR0FBN0IsVUFDRSxNQUtDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHNCQUFzQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNsRSxDQUFDO0lBRUQ7Ozs7T0FJRztJQUNJLDhDQUFtQixHQUExQjtRQUNFLFlBQVk7UUFDWiwwQkFBMEI7UUFDMUIsa0JBQWtCO1FBQ2xCLEtBQUs7UUFDTCxZQUFvQixFQUNwQixJQUFZLEVBQ1osS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLG1CQUFtQixDQUFDLFlBQVksRUFBRSxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDM0UsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxnREFBcUIsR0FBNUIsVUFDRSxNQUdDLEVBQ0QsS0FBYTtRQUViLE1BQU0sQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLHFCQUFxQixDQUFDLE1BQU0sRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNqRSxDQUFDO0lBRUQ7Ozs7OztPQU1HO0lBQ0ksZ0RBQXFCLEdBQTVCLFVBQ0UsTUFLQyxFQUNELEtBQWE7UUFFYixNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxxQkFBcUIsQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDakUsQ0FBQztJQUVEOzs7T0FHRztJQUNJLDhDQUFtQixHQUExQixVQUEyQixFQUFVLEVBQUUsS0FBYTtRQUNsRCxNQUFNLENBQUMsSUFBSSxDQUFDLGFBQWEsQ0FBQyxtQkFBbUIsQ0FBQyxFQUFFLEVBQUUsS0FBSyxDQUFDLENBQUM7SUFDM0QsQ0FBQztJQUVEOzs7Ozs7Ozs7T0FTRztJQUNJLGlEQUFzQixHQUE3QixVQUNFLE1BUUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsc0JBQXNCLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2xFLENBQUM7SUFFRDs7O09BR0c7SUFDSSxzREFBMkIsR0FBbEMsVUFBbUMsRUFBVSxFQUFFLEtBQWE7UUFDMUQsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsMkJBQTJCLENBQUMsRUFBRSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ25FLENBQUM7SUFFRDs7Ozs7T0FLRztJQUNJLGtEQUF1QixHQUE5QixVQUNFLE1BSUMsRUFDRCxLQUFhO1FBRWIsTUFBTSxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsdUJBQXVCLENBQUMsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ25FLENBQUM7SUFHSCx1QkFBQztBQUFELENBQUMsQUFoT0QsQ0FBc0MsOEJBQWEsR0FnT2xEO0FBaE9ZLDRDQUFnQiJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/oms/modules/enterprise/index.js
// module id = 219
// module chunks = 44